<template>
  <div class="withdraw-complete-container">
    <h1 v-if="!isApp" class="withdraw-complete__title">
      退会完了
    </h1>
    <div class="withdraw-complete__body">
      <img
        :src="completeImage"
        alt="withdraw_complete"
        class="withdraw-complete__complete-image"
      />
      <p class="title-bold withdraw-complete__caption">
        ご利用ありがとうございました
      </p>
      <div class="withdraw-complete__description-area">
        <p class="module-text">
          退会手続きが完了しました。
        </p>
        <p class="module-text">
          アプリをご利用の方は<br />
          アンインストールするまで<br />
          一部の情報表示が残る場合がございます。
        </p>
        <p class="module-text">
          退会自体は完了しておりますので<br />
          ご安心ください。
        </p>
      </div>
      <div v-if="!isApp" class="withdraw-complete__link-to-top-area">
        <a href="/" class="text-link-to-top">gifteeトップへ戻る</a>
      </div>
    </div>
  </div>
</template>
<script>
import completeImageSource from '../../../../../images/registration/temporary_registration_icon.svg'
export default {
  props: {
    isApp: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      completeImage: ''
    }
  },
  mounted() {
    this.completeImage = completeImageSource
  }
}
</script>
<style lang="scss" scoped>
.withdraw-complete-container {
  background-color: $white;
}

.withdraw-complete {
  &__title {
    display: none;
  }

  &__body {
    max-width: $base-contents-width;
    margin: 0 auto;
    padding: 32px 24px;
  }

  &__complete-image {
    margin-bottom: 32px;
  }

  &__caption {
    margin-bottom: 32px;
  }

  &__description-area {
    padding: 0 32px;
    margin-bottom: 24px;

    p.module-text {
      margin-bottom: 24px;
    }
  }

  &__link-to-top-area {
    display: flex;
    justify-content: center;
  }
}
</style>
